export function getVisiblePages(
  visiblePageIndex: number,
  totalPages: number,
  pageRange = 3,
): number[] {
  const pageCount = totalPages;
  const range = Math.min(pageRange, pageCount);

  let startPage = Math.max(2, visiblePageIndex - Math.floor(range / 2));
  let endPage = startPage + range - 1;

  if (endPage >= pageCount) {
    endPage = pageCount - 1;
    startPage = Math.max(2, endPage - range + 1);
  }

  return Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i,
  );
}
